import { Button, Col, Input, Row, Space, Table } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import { useRef, useState } from "react";
import Highlighter from "react-highlight-words";

export default function TableGroupDepartures({ detailsGroup }){

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
                marginBottom: 8,
                display: 'block',
            }}
            />
            <Space>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                width: 90,
                }}
            >
                Search
            </Button>
            <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                width: 90,
                }}
            >
                Reset
            </Button>
            {
                /**
                 
                <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({
                    closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
                }}
            >
                Filter
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                close();
                }}
            >
                close
            </Button>
                 */
            }
            </div>
            </Space>
        </div>
        ),
        filterIcon: (filtered) => (
        <SearchOutlined
            style={{
            color: filtered ? '#1677ff' : undefined,
            }}
        />
        ),
        onFilter: (value, record) =>
        record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
        if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
        }
        },
        render: (text) =>
        searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });

    const columns = [
        {
            title: '',
            dataIndex: 'deleted',
            key: 'deleted',
            width: '5%',
            render: (text, param, index) => {
                return(
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: '0.5em', color: param.order_deleted ? 'red': 'blue' }}>{ param.order_deleted ? 'PEDIDO ELIMINADO' : 'PEDIDO' }</span>
                        <span style={{ fontSize: '0.5em', color: param.deleted ? 'red': 'blue' }}>{ param.deleted ? 'DETALLE ELIMINADO' : 'DETALLE' }</span>
                    </div>
                );
            }
        },
        {
            title: 'Pedido',
            dataIndex: 'order',
            key: 'order',
            width: '13%',
            ...getColumnSearchProps('order'),
        },
        {
            title: 'OC',
            dataIndex: 'purchase_order',
            key: 'purchase_order',
            width: '13%',
            ...getColumnSearchProps('purchase_order'),
        },
        {
            title: 'Fecha pedido',
            dataIndex: 'date_created',
            key: 'date_created',
            width: '10%',
            ...getColumnSearchProps('date_created'),
        },
        {
            title: 'Fecha entrega',
            dataIndex: 'date_delivery',
            key: 'date_delivery',
            width: '10%',
            ...getColumnSearchProps('date_delivery'),
        },
        {
            title: 'Producto',
            dataIndex: 'ref',
            key: 'ref',
            width: '10%',
            ...getColumnSearchProps('ref'),
        },
        {
            title: 'Color',
            dataIndex: 'color',
            key: 'color',
            width: '5%',
            ...getColumnSearchProps('color'),
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            width: '5%',
            ...getColumnSearchProps('type'),
        },
        {
            title: 'Cantidad',
            dataIndex: 'quantity',
            key: 'quantity',
            width: '5%',
            ...getColumnSearchProps('quantity'),
        },
    ];

    return(
        <Row>
            <Col lg={24} xs={24}>
            <Table columns={columns} dataSource={detailsGroup} size='small' pagination={false} />
            </Col>
        </Row>
    );
}